import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  statsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  statsCard: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[2],
    },
  },
  statsCardInner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
  },
  statsIconBox: {
    width: 40,
    height: 40,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  statsContent: {
    flex: 1,
    minWidth: 0,
  },
  statsValue: {
    fontSize: 22,
    fontWeight: 700,
    lineHeight: 1.2,
    color: theme.palette.text.primary,
  },
  statsLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  progressBg: {
    backgroundColor: colors.blue[50],
  },
  answeredBg: {
    backgroundColor: colors.green[50],
  },
  pendingBg: {
    backgroundColor: colors.orange[50],
  },
  complianceBg: {
    backgroundColor: colors.purple[50],
  },
  progressIcon: {
    color: colors.blue[600],
  },
  answeredIcon: {
    color: colors.green[600],
  },
  pendingIcon: {
    color: colors.orange[600],
  },
  complianceIcon: {
    color: colors.purple[600],
  },
}))

export default styles
